<template>
    <div class="container p-0">
        <canvas style="pointer-events: none; position: fixed; top: 0; left: 0;" id="confetti-holder"></canvas>
        <List v-if="loaded && list" />
        <MasterClass v-if="loaded && !list" />
    </div>
</template>

<script>
    import List from './components/List.vue'
    import MasterClass from './components/MasterClass.vue'

    export default {
        name: 'App',
        components: {
            MasterClass,
            List
        },
        data: function(){
            return {
                list: true,
                loaded: false
            }
        },
        mounted: function(){
            this.list = !window.location.pathname.includes('/class/view/') && !window.location.pathname.includes('.html')  
            this.loaded = true;
        },
        methods: {

        }
    }
</script>
